module.exports = __webpack_public_path__ + "static/media/View-Services-Icon-White.4157f6b1.svg";